import {init_hash_listener} from "./hash_listener";

init_hash_listener();